import { z } from 'zod';
export const SocialPageSchema = z.union([
    z.object({
        url: z.string(),
        status: z.literal('detected')
    }),
    z.object({
        url: z.null(),
        status: z.literal('missing')
    })
]);
export const SocialMediaSchema = z.object({
    facebook: SocialPageSchema.nullish(),
    instagram: SocialPageSchema.nullish(),
    tiktok: SocialPageSchema.nullish(),
    linkedin: SocialPageSchema.nullish(),
    twitter: SocialPageSchema.nullish()
}).meta({
    id: 'SocialMedia'
});

//# sourceMappingURL=social-media.schema.js.map